export default str =>
  str
    .replace(/(^|\s)\S/g, l => l.toUpperCase())
    .replace(/(\B)[^ ]*/g, match => match.toLowerCase())
    .replace(/\s+/g, ' ')
    .trim();
